export enum GROUPS_ORDER_COLUMNS {
  NAME = 'NAME',
  CODE = 'CODE',
  WORKLOAD = 'WORKLOAD',
  TEACHERS = 'TEACHERS',
}
